type LengthUnits = "cm" | "km" | "m" | "mm" | "ft" | "inch";
type MassUnits = "kg" | "g" | "lbs";
export type ConversionUnits = LengthUnits | MassUnits;

type ConversionUnitOptionValue = {
  label: string;
  value: ConversionUnits;
  convert: (val: number) => typeof val;
};

type ConversionOptions = Record<ConversionUnits, Array<ConversionUnitOptionValue>>;

export const options: ConversionOptions = {
  kg: [
    { label: "pound", value: "lbs", convert: (val) => val * 2.205 },
    { label: "gram", value: "g", convert: (val) => val * 1000 },
  ],
  g: [
    { label: "kilogram", value: "kg", convert: (val) => val / 1000 },
    { label: "pound", value: "lbs", convert: (val) => val / 453.6 },
  ],
  lbs: [
    { label: "kilogram", value: "kg", convert: (val) => val / 2.205 },
    { label: "gram", value: "g", convert: (val) => val * 453.6 },
  ],
  cm: [
    { label: "inch", value: "inch", convert: (val) => val / 2.54 },
    { label: "kilometer", value: "km", convert: (val) => val / 100000 },
    { label: "meter", value: "m", convert: (val) => val / 100 },
    { label: "milimeter", value: "mm", convert: (val) => val * 10 },
    { label: "foot", value: "ft", convert: (val) => val / 30.48 },
  ],
  km: [
    { label: "inch", value: "inch", convert: (val) => val * 39370 },
    { label: "centimeter", value: "cm", convert: (val) => val * 100000 },
    { label: "meter", value: "m", convert: (val) => val * 1000 },
    { label: "milimeter", value: "mm", convert: (val) => val * 1000000 },
    { label: "foot", value: "ft", convert: (val) => val * 3281 },
  ],
  m: [
    { label: "inch", value: "inch", convert: (val) => val * 39.37 },
    { label: "centimeter", value: "cm", convert: (val) => val * 100 },
    { label: "kilometer", value: "km", convert: (val) => val / 1000 },
    { label: "milimeter", value: "mm", convert: (val) => val * 1000 },
    { label: "foot", value: "ft", convert: (val) => val * 3.281 },
  ],
  mm: [
    { label: "inch", value: "inch", convert: (val) => val / 25.4 },
    { label: "centimeter", value: "cm", convert: (val) => val / 10 },
    { label: "kilometer", value: "km", convert: (val) => val / 1000000 },
    { label: "meter", value: "m", convert: (val) => val / 1000 },
    { label: "foot", value: "ft", convert: (val) => val / 304.8 },
  ],
  ft: [
    { label: "inch", value: "inch", convert: (val) => val * 12 },
    { label: "centimeter", value: "cm", convert: (val) => val * 30.48 },
    { label: "kilometer", value: "km", convert: (val) => val / 3281 },
    { label: "meter", value: "m", convert: (val) => val / 3.281 },
    { label: "milimeter", value: "mm", convert: (val) => val * 304.8 },
  ],
  inch: [
    { label: "centimeter", value: "cm", convert: (val) => val * 2.54 },
    { label: "kilometer", value: "km", convert: (val) => val / 39370 },
    { label: "meter", value: "m", convert: (val) => val / 39.37 },
    { label: "milimeter", value: "mm", convert: (val) => val * 25.4 },
    { label: "foot", value: "ft", convert: (val) => val / 12 },
  ],
};
